/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entryfreehint2Inputs */

const en_entryfreehint2 = /** @type {(inputs: Entryfreehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just come by`)
};

const de_entryfreehint2 = /** @type {(inputs: Entryfreehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfach vorbeikommen`)
};

/**
* | output |
* | --- |
* | "Just come by" |
*
* @param {Entryfreehint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entryfreehint2 = /** @type {((inputs?: Entryfreehint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entryfreehint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entryfreehint2(inputs)
	return de_entryfreehint2(inputs)
});
export { entryfreehint2 as "entryFreeHint" }